import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    item: {},
    items: [],
    itemsTotal: 0,
    icreas: [],
    loading: true,
    institution: null,
    file: null,
    fileIcreas: [],
    alerts: [],
    alertsTotal: 0,
    icrea: [],
    caeId: null,
    fileResponses: [],
    fileResponsesTotal: 0,
    fileResponsesDocument: null,
    fileResponsesHosts: [],
    fileResponsesId: null,
  },
  getters: {
    items: state => state.items,
    icreas: state => state.icreas,
    icrea: state => state.icrea,
    itemsTotal: state => state.itemsTotal,
    item: state => state.item,
    loading: state => state.loading,
    institution: state => state.institution,
    file: state => state.file,
    alerts: state => state.alerts,
    alertsTotal: state => state.alertsTotal,
    fileIcreas: state => state.fileIcreas,
    caeId: state => state.caeId,
    fileResponses: state => state.fileResponses,
    fileResponsesTotal: state => state.fileResponsesTotal,
    fileResponsesDocument: state => state.fileResponsesDocument,
    fileResponsesHosts: state => state.fileResponsesHosts,
  },
  mutations: {
    SAVE_FILE(state, file) {
      state.file = file
    },
    SAVE_INSTITUTION(state, institution) {
      state.institution = institution
    },
    TOGGLE_LOADING(state, loading) {
      state.loading = loading
    },
    SAVE_ITEMS(state, items) {
      state.items = items
    },
    SAVE_ICREAS(state, icreas) {
      state.icreas = icreas
    },
    SAVE_ICREA(state, icrea) {
      state.icrea = icrea
    },
    SAVE_ITEM(state, item) {
      state.item = item
    },
    SAVE_ITEMS_TOTAL(state, itemsTotal) {
      state.itemsTotal = itemsTotal
    },
    CLEAR_ITEMS(state) {
      state.items = []
      state.item = {}
      state.icreas = []
    },
    CLEAR_ITEM(state) {
      state.item = {
        active: true,
      }
    },
    SAVE_ALERTS(state, alerts) {
      state.alerts = alerts
    },
    SAVE_ALERTS_TOTAL(state, alerts) {
      state.alertsTotal = alerts
    },
    SAVE_FILE_ICREAS(state, fileIcreas) {
      state.fileIcreas = fileIcreas
    },
    SAVE_CAE_ID(state, caeId) {
      state.caeId = caeId
    },
    SAVE_FILE_RESPONSES(state, responses) {
      state.fileResponses = responses
    },
    SAVE_FILE_RESPONSES_TOTAL(state, total) {
      state.fileResponsesTotal = total
    },
    SAVE_FILE_RESPONSES_DOCUMENT(state, file) {
      state.fileResponsesDocument = file
    },
    SAVE_FILE_RESPONSES_HOSTS(state, hosts) {
      state.fileResponsesHosts = hosts ?? []
    },
    SAVE_FILE_RESPONSES_ID(state, id) {
      state.fileResponsesId = id
    },
  },
  actions: {
    async acceptDocument({ commit }, data) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/accept-file`, data)
        commit('SAVE_FILE', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async uploadResponse({ commit }, data) {
      try {
        const formData = new FormData()
        formData.append('file', data.response)
        formData.append('file_id', data.file)
        // Prefer the caller-resolved safe host_id; fall back to the filter only when
        // it is actually set, so a deep-link without ?host= never sends "undefined".
        const hostId = data.host_id ?? (data.filters.host ? data.filters.host.id : null)
        if (hostId !== null && hostId !== undefined) formData.append('host_id', hostId)
        await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/upload-file-response`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/view-file/${data.file}`, data.filters)
        commit('SAVE_FILE', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async deleteResponse({ commit }, data) {
      try {
        await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/delete-file-response/${data.id}`, data.filters)
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/view-file/${data.file}`, data.filters)
        commit('SAVE_FILE', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async fetchFile({ commit }, data) {
      try {
        if (localStorage.getItem('currentRoute').includes('admin.occupational-hazards')) {
          data.filters.only_admin = true
        }
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/view-file/${data.id}`, data.filters)
        commit('SAVE_FILE', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    saveInstitution({ commit }, institution) {
      commit('SAVE_INSTITUTION', institution)
    },
    clear({ commit }) {
      commit('CLEAR_ITEMS')
    },
    async fetchIcreas({ commit }, filters) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/icreas`, filters)
        commit('SAVE_ICREAS', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async fetchId({ commit }, data) {
      try {
        if (localStorage.getItem('currentRoute').includes('admin.occupational-hazards')) {
          data.filters.only_admin = true
        }
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/view/${data.id}`, data.filters)
        commit('SAVE_ITEM', resp.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    setCaeId({ commit }, id) {
      commit('SAVE_CAE_ID', id)
    },
    async filterId({ commit, state }, data) {
      try {
        if (!state.caeId) {
          return
        }
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/view/filter/${state.caeId}`, data)
        console.log(resp.data)
        commit('SAVE_ITEM', resp.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async fetch({ commit }, filters) {
      try {
        const data = filters
        if (localStorage.getItem('currentRoute').includes('admin.occupational-hazards')) {
          data.only_admin = true
        }
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/sections`, data)
        commit('SAVE_ITEMS', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async fetchDocumentIcreas({ commit }, data) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/view-file/icreas/${data.document}`, data.filters)
        commit('SAVE_FILE_ICREAS', resp.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    toggleLoading({ commit }, loading) {
      commit('TOGGLE_LOADING', loading)
    },
    async globalFilter({ dispatch }, filters) {
      await dispatch('fetch', filters)
      await dispatch('fetchIcreas', filters)
    },
    async filterFiles({ commit }, filters) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/files`, filters)
        commit('SAVE_ITEMS', resp.data.data)
        // commit('SAVE_ITEMS_TOTAL', resp.data.total)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async fetchUser({ commit }, id) {
      try {
        const resp = await Vue.prototype.$http.get(`${Vue.prototype.$groupUrl}/cae/icrea/${id}`)
        commit('SAVE_ICREA', resp.data.data)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    // Every answer to one document. Nothing used to return more than one: the
    // document page resolves a single response and its "See all responses" link went
    // to the Alerts screen, which is not scoped to a document at all.
    // The document id lives in the store because CompleteTable's paginator, filter
    // offcanvas and sortable headers all re-dispatch this action with the filters
    // object alone — they have no way to pass the route param.
    saveFileResponsesId({ commit }, id) {
      commit('SAVE_FILE_RESPONSES_ID', id)
    },
    async filterFileResponses({ commit, state }, filters) {
      if (!state.fileResponsesId) return
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/files/${state.fileResponsesId}/responses/filter`, filters ?? {})
        commit('SAVE_FILE_RESPONSES', resp.data.data)
        commit('SAVE_FILE_RESPONSES_TOTAL', resp.data.total)
        // The document and the hosts that answered travel with the responses, so the
        // screen needs one request rather than a second one just to fill a heading
        // and a filter dropdown.
        commit('SAVE_FILE_RESPONSES_DOCUMENT', resp.data.file)
        commit('SAVE_FILE_RESPONSES_HOSTS', resp.data.hosts)
      } catch (e) {
        commit('SAVE_FILE_RESPONSES', [])
        commit('SAVE_FILE_RESPONSES_TOTAL', 0)
        commit('SAVE_FILE_RESPONSES_DOCUMENT', null)
        commit('SAVE_FILE_RESPONSES_HOSTS', [])
      }
    },
    async fetchAlerts({ commit }) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/alerts/filter`)
        commit('SAVE_ALERTS', resp.data.data)
        commit('SAVE_ALERTS_TOTAL', resp.data.total)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async fetchAlertsActive({ commit }) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/alerts/active`)
        commit('SAVE_ALERTS', resp.data.data)
        commit('SAVE_ALERTS_TOTAL', resp.data.total)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async archiveAlert({ commit }, id) {
      try {
        await Vue.prototype.$http.get(`${Vue.prototype.$alertUrl}/cae/alerts/${id}/archive`)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
    async filterAlerts({ commit }, filters) {
      try {
        const resp = await Vue.prototype.$http.post(`${Vue.prototype.$groupUrl}/cae/alerts/filter`, filters)
        commit('SAVE_ALERTS', resp.data.data)
        commit('SAVE_ALERTS_TOTAL', resp.data.total)
      } catch (e) {
        commit('CLEAR_ITEMS')
      }
    },
  },
}
